import LegalPage from "../../components/legal/LegalPage";
import document from "../../content/legal/disclaimer.json";

export default function Page() {
  return <LegalPage title="Disclaimer" document={document} />;
}
